import { Component } from '@angular/core';

@Component({
    templateUrl: './luvema-landing.template.html',
    styleUrls: ['./luvema-landing.component.css']
})
export class LuvemaLandingComponent { }